module.exports = __webpack_public_path__ + "static/empty-states-body-do-d3e735e190b4f615c6db923433a6d747.png";